const defaultState = () => {
  return {
    text: ''
  }
}

const state = defaultState()

const getters = {
  text: state => state.text
}

const mutations = {
  setText(state, text) {
    state.text = text
  },
  resetModule(state) {
    Object.assign(state, defaultState())
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
